/** @prettier */
import interact from 'interactjs';
import {useRef, useEffect, CSSProperties} from 'react';

import {specialID} from '../define';

export function useInteractJS() {
  const draggableRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (draggableRef.current) {
      // interact.jsでドラッグ操作を有効にする
      interact(draggableRef.current).draggable({
        inertia: true,
        //ドラッグ移動を部分的に無効化したいコンポーネントのidに以下のidを設定することで無効化。
        //スライダー操作やポップアップグラフの拡大等ドラッグによる操作が行えないため。
        ignoreFrom: `#${specialID.IGNORE_INTERACTJS_ID}`,
        listeners: {
          move(event) {
            const target = event.target as HTMLElement;
            // 既存の位置を取得
            const x =
              (parseFloat(target.getAttribute('data-x')!) || 0) + event.dx;
            const y =
              (parseFloat(target.getAttribute('data-y')!) || 0) + event.dy;

            // 新しい位置を適用
            target.style.transform = `translate(${x}px, ${y}px)`;

            // 新しい位置を保存
            target.setAttribute('data-x', x.toString());
            target.setAttribute('data-y', y.toString());
          },
        },
      });
    }
  }, []);

  return {
    // 返り値にrefとCSSのスタイルを追加する。動かしたいコンポーネントに適用することで、コンポーネントが実際に動くようになる
    ref: draggableRef,
    style: {
      width: '100px',
      height: '100px',
      position: 'absolute' as CSSProperties['position'],
    },
  };
}
